import React, { useContext, useState,useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link, useSearchParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { FloatCardComponent } from "../../components/cards";
import ProductsTableComponent from "../../components/tables/ProductsTableComponent";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import { PaginationComponent } from "../../components";
import PageLayout from "../../layouts/PageLayout";
import drafts from "../../assets/data/drafts.json";
import { VerifiedTableComponent } from "../../components/tables";
import axios from "axios";
export default function VerifiedList() {

    const AuthToken = localStorage.getItem("AuthUser");
    const [data,setData] = useState([]);
    // ?request=ID → selecting families to add to an existing fund forecast request
    const [searchParams] = useSearchParams();
    const requestId = searchParams.get("request");
    const [forecastRequest, setForecastRequest] = useState(null);
    useEffect(() => {
        const fetchData = async () => {
          try {
            axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
            let params = {};
            if (requestId) {
              const res = await axios.get(process.env.REACT_APP_API_URL + "/edit-forecast/" + requestId);
              setForecastRequest(res.data);
              // Only families this request's donor can be given
              params = { donor_id: res.data.forecast?.loan_donor_id };
            }
            const response = await axios.get(
              process.env.REACT_APP_API_URL + "/verified-list", { params }
            );
            setData(response.data.families);

          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };

        fetchData();
      }, [requestId]);
    const remaining = forecastRequest
        ? Math.max((forecastRequest.forecast?.requested_families || 0) - forecastRequest.families_count, 0)
        : undefined;
    const { t, n } = useContext(TranslatorContext)
    
    const floats = [
        { "title": "Pending Families", "digit": 547, "icon": "donut_large", "variant": "lg purple" },
        { "title": "Requested Families", "digit": 249, "icon": "widgets", "variant": "lg yellow" }, 
        { "title": "Approved Families", "digit": 605, "icon": "approval", "variant": "lg blue" },
        { "title": "Rescued Families", "digit": 1050, "icon": "sports_score", "variant": "lg green" }
      
    ]
    const mappedData = data.map((person) => ({
        id: person.id || "",
        fsf_id: person.f_number || "",
        beneficiary_cnic: person.cnic || "",
        beneficiary_name: person.beneficiary_name || "",
        partner_name: person.identifier?.name || "", // Assuming the same name
        organization_church: person.identifier?.org || "",
        verified_by: person.verifier?.name, // Static value, replace if dynamic
        total_loan_amount: person.loan?.est_loan_amount || 0,
      
        status: person.stage?.name, // Static value, replace if dynamic
        action: {
          edit: "edit",
          delete: "delete",
          view: "visibility",
        },
      }));
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{'Verified Families List'}</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link"style={{color:"#077834"}}>{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link"style={{color:"#077834"}}>{t('Families')}</Link></li>
                                <li className="mc-breadcrumb-item">{'Verified List'}</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                {/* {floats.map((float, index) => (
                    <Col key={ index } sm={6} lg={3}>
                        <FloatCardComponent 
                            variant={ float.variant }
                            digit={n(float.digit)}
                            title={t(float.title)}
                            icon={ float.icon }
                        />
                    </Col>
                ))} */}
                <Col xl={12}>
                    <div className="mc-card">
                        <Row>
                           
                            {forecastRequest && (
                                <Col xl={12}>
                                    <p className="p-2">
                                        <b>
                                            Adding families to request {forecastRequest.forecast?.rfq_id}:{" "}
                                            {forecastRequest.is_locked
                                                ? "this request is locked."
                                                : `${remaining} more can be added.`}
                                        </b>
                                    </p>
                                </Col>
                            )}
                            <Col xl={12}>
                                <VerifiedTableComponent
                                    thead={ drafts.thead }
                                    tbody={ mappedData }
                                    proceedTo={ requestId ? `/add-forecast-families/${requestId}` : undefined }
                                    maxSelect={ forecastRequest ? (forecastRequest.is_locked ? 0 : remaining) : undefined }
                                />
                                {/* <PaginationComponent /> */}
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}
